import React, { useState, useEffect } from 'react';
import DataTable from '../../../interfaccia/DataTableBase';
import ApriElementoDiLista from '../../../interfaccia/tasti/ApriElementoDiLista';
import stilePulsanti from '../../../interfaccia/stilePulsanti';

function ListaBrands({
  mobile,
  utente,
  lista,
  apriElemento,
  loading
}) {

  const [rows, setRows] = useState(
    lista
  )

  useEffect(() => {
    setRows(lista)
  }, [lista]);

  const colonnaApriElemento = function (nomeDato, labelDato, width, idSped, sortField, compact, conditionalCellStyles) {
    return ({
      selector: row => row[nomeDato],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      sortField: sortField,
      conditionalCellStyles: conditionalCellStyles,
      cell: (row) => <div className="rowitem"><ApriElementoDiLista id={row[idSped]} testo={row[nomeDato]} apriElemento={apriElemento}/></div>
     
    })
  }

  const colonnaApriCartella = function (nomeDatoRead, nomeDatoWrite, labelDato, width, compact) {
    return ({
      selector: row => row[nomeDatoRead],
      name: labelDato,
      sortable: true,
      ignoreRowClick: true,
      reorder: true,
      compact: compact ? true : false,
      width: width + "px",
      cell: (row) => {
        if (utente.permessiAPI["update:database"] && row[nomeDatoWrite]) {
          return(<div className="rowitem">
            <a href={row[nomeDatoWrite]}  target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite}><span className='material-icons f3'>folder</span></a>
          </div>)
        } else if ((utente.permessiAPI["read:database"] && row[nomeDatoRead]) || (utente.permessiAPI["update:database"] && row[nomeDatoRead])) {
          return(<div className="rowitem">
            <a href={row[nomeDatoRead]}  target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite}><span className='material-icons f3'>folder</span></a>
          </div>)
        } else {
          return <div className="rowitem"></div>
        }
        }
     
    })
  }

  const columns = [
    colonnaApriElemento('nome', 'Nome', 300, 'id', false,false),
    colonnaApriCartella("linkFolderRead", "linkFolderWrite", 'files', 50, true)
  ];

  return (
    <div
      className="h-100"
    >
      <DataTable
        data={rows}
        columns={columns}
        fixedHeader={false}
        fixedHeaderScrollHeight={"100px"}
        striped={false}
        progressPending={loading}
        noDataComponent={<h3 className='ma5 pa5'>Nessun contatto risponde alla tua ricerca.</h3>}
        progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
        pagination
        paginationRowsPerPageOptions={[10,50,200]}
        paginationPerPage={10}
        paginationComponentOptions={{ rowsPerPageText: '', rangeSeparatorText: 'di', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Seleziona tutti' }}
      />
      
    </div>
  )
}

export default ListaBrands;